module.exports = __webpack_public_path__ + "slider6.7231ec1be088f3fe3058.jpg";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/slider/slider6.jpg
// module id = ../../../../../src/assets/images/slider/slider6.jpg
// module chunks = styles